<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sGwfTl/tc-custom/9781400205189.jpg?1731055260701" alt="This image is the cover for the book Strange Fire"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Strange Fire
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In <i>Strange Fire</i>, bestselling author and pastor John MacArthur chronicles the unsavory history behind the modern Charismatic movement.</b></p><p>What would God say about those who blatantly misrepresent His Holy Spirit; who exchange true worship for chaotic fits of mindless ecstasy; who replace the biblical gospel with vain illusions of health and wealth; who claim to prophesy in His name yet speak errors; and who sell false hope to desperate people for millions of dollars?</p><p>The charismatic movement has always been a breeding-ground for scandal, greed, bad doctrine, and all kinds of spiritual chicanery. As a movement, it is clearly headed the wrong direction. And it is growing at an unprecedented rate.</p><p>From the Word of Faith to the New Apostolic Reformation, the Charismatic movement is being consumed by the empty promises of the prosperity gospel. Too many charismatic celebrities promote a “Christianity” without Christ, a Holy Spirit without holiness. And their teaching is having a disastrous influence on a grand scale, as large television networks broadcast their heresies to every part of the world.</p><p>In <i>Strange Fire</i>, MacArthur lays out a chilling case against the modern Charismatic movement that includes:</p>Rejecting its false prophets.Speaking out against their errors.Showing true reverence to the Holy Spirit.Clinging to the Bible as the inerrant, authoritative Word of God and the one true standard by which all truth claims must be tested.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John MacArthur
      </h2>
      
      <p class="authorDescription body article"><P>Widely known for his thorough, candid approach to teaching God's Word, John MacArthur is a popular author and conference speaker. He has served as pastor-teacher of Grace Community Church in Sun Valley, California, since 1969. John and his wife, Patricia, have four married children and fifteen grandchildren. John's pulpit ministry has been extended around the globe through his media ministry, Grace to You, and its satellite offices in seven countries. In addition to producing daily radio programs for nearly two thousand English and Spanish radio outlets worldwide, Grace to You distributes books, software, and digital recordings by John MacArthur. John is&#160;chancellor of The Master's University and Seminary and has written hundreds of books and study guides, each one biblical and practical. Bestselling titles include <I>The Gospel &#160;According to Jesus</I>, <I>Twelve Ordinary Men</I>, <I>Twelve Extraordinary Women</I>, <I>Slave</I>, and <I>The MacArthur Study Bible</I>, a 1998 ECPA Gold Medallion recipient.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c326d8c